import queryString from 'query-string';

export const ADMIN_BASE_ROUTE = '/admin';
export const PENDING_ADMIN_ACTION = (pendingAdminTab?: string, queryParams?: object) =>
  `/pending-admin-action/${pendingAdminTab || ':pendingAdminTab?'}${
    queryParams ? `?${queryString.stringify(queryParams)}` : ''
  }`;

export const ACCOUNT = '/account';
export const ACCOUNT_BILLING = '/account/billing';
export const ACCOUNT_USER = '/account/user';
export const ACCOUNT_SETTINGS = '/account/information';
export const ORG_JOBS = '/jobs';
export const BUSINESS_INFORMATION_FORM = '/business-information';
export const EMPLOYEE_DIRECTORY_IMPORTS = '/employee-directory-imports';
export const MERGE_INTEGRATION_DASHBOARD = '/merge-integration';
